<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-domain
      </v-icon> Organization List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-col
        cols="12"
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createOrganization()"
        >
          <v-icon dark>
            mdi-pencil
          </v-icon>
          Create New
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="organizationList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.type }}</td>
            <td>
              {{ item.external_id }}
            </td>
            <td>
              <span v-if="item.tax_id !== null">
                {{ showTaxType(item.tax_id) }}
              </span>
              <span v-else>
                N/A
              </span>
            </td>

            <td>{{ item.updated_at | diffHumans }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="getOrganizationDetailContent(item.external_id)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="editOrganization(item.external_id)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#C62828"
                @click="deleteOrganization()"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';

  export default {
    name: 'OrganizationList',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Type', value: 'type' },
          { text: 'Organization Id', value: 'external_id' },
          { text: 'Tax Type', value: 'tax_id' },
          { text: 'Last Updated', value: 'updated_at' },
          { text: 'More', value: 'more' },
          { text: 'Edit', value: 'edit' },
          { text: 'Delete', value: 'delete' },
        ],
      };
    },
    computed: {
      organizationList () {
        const list = this.$store.getters['organizations/getOrganizationList'];
        const sortedList = list.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        return sortedList;
      },
      taxRates () {
        return this.$store.getters['payments/getTaxRates'];
      },
      CountryCodeList () {
        return this.$store.getters['users/getCountryCodes'];
      },
    },
    async mounted () {
      await this.getOrganizationList();
      await this.fetchTaxRates();
      this.getCountryCodes();
    },
    methods: {
      async getOrganizationList () {
        this.loading = true;
        await this.$store.dispatch('organizations/fetchOrganizationList');
        this.loading = false;
      },
      deleteOrganization () {
        this.$store.dispatch('alert/onAlert', {
          message: 'Yor are not authorized to delete the organization details from the list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
      createOrganization () {
        this.$router.push({ name: 'Create Organization' });
      },
      getOrganizationDetailContent (organizationId) {
        this.$router.push(`organizations/${organizationId}`);
      },
      editOrganization (organizationId) {
        this.$router.push(`organizations/edit/${organizationId}`);
      },
      async fetchTaxRates () {
        await this.$store.dispatch('payments/fetchTaxRates');
      },
      getCountryCodes () {
        this.$store.dispatch('users/fetchCountryCodes');
      },
      showTaxType (taxId) {
        const filteredTaxType = this.taxRates.filter(i =>
          i.id === taxId);
        if (filteredTaxType.length > 0) {
          const taxName = filteredTaxType[0].name.toUpperCase();
          const countryName = this.CountryCodeList[filteredTaxType[0].country];
          return `${taxName} - ${countryName}`;
        }
      },
    },
  };
</script>
<style scoped>
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.title-style {
  color: #37474F;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
.title-style {
  color: #37474F;
}
</style>
